export default __webpack_public_path__ + "static/silverLtag-76ed12c27abf8833c0014a2aa60997f4.png";